import React, { Suspense, useState, useEffect } from "react";
import "../UserNotification/Notification.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";

import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { getNotification } from "../../actions/notificationAction";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import "moment/locale/en-in";

import "moment/locale/is";

import "moment/locale/pl";
import "moment/locale/es";
import { Box, Pagination } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f5d792",
      darker: "#053e85",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

const UserNotification = (props) => {
  const { frontLabelsName } = props.label;
  const lng = localStorage.getItem("prevLangFront") 
  const notifications = useSelector((state) => state.notifications);
  const { notificationLoading, notificationList } = notifications;

  const [page, setPage] = useState(1);

  const [rowsPerPage, setRowsPerPage] = useState(20);

  useEffect(() => {
    props.getNotification(page, rowsPerPage, "");
  }, [page]);

  const handleChange = (e, p) => {
    setPage(p);
    props.getNotification(p, rowsPerPage, "");
  };

  if (!['en-in', 'is', 'pl', 'es'].includes(lng)) {

    moment.locale('en');  // fallback to English if the locale is not supported
  } else {
    moment.locale(lng); // Set locale dynamically
  }
 

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
      
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="main-white-box">
              <div className="my-notification-box11">
                <div className="row ">
                  {!notificationLoading && notificationList.docs.length > 0 ? (
                    notificationList.docs.map((noti, i) => (
                      <div className="main-notify">
                        <div className="col-lg-1 text-center">
                          <img
                            src={noti?.user?.profile_pic}
                            alt="user-notification"
                            width="64"
                            height="64"
                            style={{ borderRadius: "50%" }}
                          />
                        </div>
                        <div className="col-lg-9">
                          <div className="align-item-center">
                            <p className="set-fn-notification">
                              {noti?.content}
                            </p>
                            <h7 className="set-fn-notification">
                              {noti?.title}
                            </h7>
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <p className="text-left">
                            {moment(noti.createdAt)
                              .startOf("seconds")
                              .fromNow()}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_no_notification_found"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_no_notification_found"
                            )[0]["value"] || "lbl_no_notification_found"
                          : "lbl_no_notification_found"
                        : "lbl_no_notification_found"}
                    </div>
                  )}
                  {notificationList.docs.length > 0 && !notificationLoading && (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      mt={4}
                    >
                      <ThemeProvider theme={theme}>
                        {notificationList.docs.length > 0 &&
                          !notificationLoading && (
                            <Pagination
                              count={notificationList.totalPages}
                              color="primary"
                              page={page}
                              onChange={handleChange}
                              shape="rounded"
                              sx={{ textAlign: "center" }}
                            />
                          )}
                      </ThemeProvider>
                    </Box>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});
export default connect(mapStateToProps, { getNotification })(UserNotification);
